var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 4267 4267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15551,0,0,1.15551,-82.1737,145.306)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(44.0721,0,0,44.0721,1104.02,1514.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,6C19.611,6 16,9.611 16,14C16,18.389 19.611,22 24,22C28.389,22 32,18.389 32,14C32,9.611 28.389,6 24,6ZM24,23.463C17.992,23.463 6,25.678 6,30.075L6,32.279C6,33.09 6.896,33.748 8,33.748L40,33.748C41.104,33.748 42,33.09 42,32.279L42,30.075C42,25.678 30.008,23.463 24,23.463Z",
    style: {
      fill: "rgb(65,65,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.94687,1.03033,1.03033,3.94687,7447.19,-7241.13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,1565.18,1401.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.046,112.908L73.386,90.525L26.064,82.341L13.635,82.731C11.457,82.8 9.54,84.186 8.793,86.235C7.785,89.001 9.213,92.058 11.979,93.066L113.943,130.176C116.709,131.184 119.766,129.756 120.774,126.99C121.518,124.941 120.942,122.646 119.319,121.194L110.046,112.908Z",
    style: {
      fill: "rgb(238,177,61)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,1565.18,1401.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.965,25.095L87.168,18.981L89.205,13.383C90.894,8.745 96.021,6.354 100.659,8.04C105.297,9.729 107.688,14.856 106.002,19.494L103.965,25.095Z",
    style: {
      fill: "rgb(238,177,61)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,1565.18,1401.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.294,76.515C131.736,53.325 119.778,27.681 96.585,19.239C73.392,10.797 47.751,22.755 39.309,45.948C38.913,47.037 26.064,82.341 26.064,82.341L110.049,112.908C110.046,112.908 122.895,77.604 123.294,76.515Z",
    style: {
      fill: "rgb(242,202,82)",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4d0f42b3e152ee341978ec29fa317d61.svg";
export { ForwardRef as ReactComponent };